import useSWR from 'swr';
import { PDPSizes } from '@/data/types/PdpSizes';

const fetcher = async () => {
	const response = await fetch('/api/pdp_sizes');

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const data = await response.json();

	return data as PDPSizes;
};

const GET_PDP_SIZES_DATA_KEY = 'GET_PDP_SIZES_DATA_KEY';

export const useGetPDPSizes = () => {
	const baseQuery = useSWR(GET_PDP_SIZES_DATA_KEY, fetcher);
	return baseQuery;
};
